import Stylus from './Stylus';
import wireframePromo from '../assets/icons/wireframePromo.svg';
import { svgToIcon } from '../utils/svg';

class StylusWireframePromo extends Stylus {
  async activate() {
    super.activate();

    await this.controller.actionOpenWireframePromo();
  }

  renderIcon() {
    return svgToIcon(wireframePromo);
  }

  description() {
    return 'wireframepromo';
  }

  isPromotion() {
    return true;
  }
}

export default StylusWireframePromo;
